import React from 'react';
import {
  Filter as FilterAdmin,
  TextInput,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';

import { STATUS_ATIVO } from '../../utils';

const choicesExposicao = [
  { id: 'nao-exposto', name: 'Não Exposto' },
  { id: 'unica', name: 'Única' },
  { id: 'duplicada', name: 'Duplicado' },
  { id: 'triplicada', name: 'Triplicado' },
  { id: 'mais-de-3', name: 'Mais de 3' },
];

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="Descrição" source="nome" />
    <ReferenceInput
      fullWidth
      label="Produto"
      source="produto_id"
      reference="produtos_search_filter"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      perPage={10}
      allowEmpty={false}
      filter={{ status: STATUS_ATIVO, is_pallet_exposicao: true }}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
    <SelectInput
      source="exposicao"
      choices={choicesExposicao}
      label="Exposição"
      allowEmpty={false}
    />
  </FilterAdmin>
);

export default Filter;
